import { Component, Input } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";

@Component({
  selector: "figma-link",
  template: ` <div class="figma-link-wrapper">
    <a [href]="_figmaLink" target="_blank" rel="noopener noreferrer">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 57">
        <path
          fill="#1abcfe"
          d="M19 28.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0"
        ></path>
        <path
          fill="#0acf83"
          d="M0 47.5A9.5 9.5 0 0 1 9.5 38H19v9.5a9.5 9.5 0 1 1-19 0"
        ></path>
        <path fill="#ff7262" d="M19 0v19h9.5a9.5 9.5 0 1 0 0-19z"></path>
        <path
          fill="#f24e1e"
          d="M0 9.5A9.5 9.5 0 0 0 9.5 19H19V0H9.5A9.5 9.5 0 0 0 0 9.5"
        ></path>
        <path
          fill="#a259ff"
          d="M0 28.5A9.5 9.5 0 0 0 9.5 38H19V19H9.5A9.5 9.5 0 0 0 0 28.5"
        ></path>
      </svg>
    </a>
  </div>`,
  styleUrls: ["figma.link.component.scss"],
})
export class FigmaLinkComponent {
  public translations$: Observable<ITranslations>;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }

  public _figmaLink: string;

  @Input("figmaLink") set figmaLink(figmaLink: string) {
    this._figmaLink = figmaLink;
  }
}



// WEBPACK FOOTER //
// ./src/app/development/figma/figma.link.component.ts